export default function SvgImgError() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="66"
      viewBox="0 0 46 66"
      fill="none"
      className="my-4 self-center">
      <path
        d="M22.5794 59.2294C22.5794 59.2294 17.2736 59.551 11.6462 57.7829C6.01891 56.0148 2.96438 50.0659 3.12585 47.9761C3.28598 45.8864 7.1452 41.8671 7.1452 41.8671L26.2771 43.7967L26.7588 57.6228L22.5794 59.2308V59.2294Z"
        fill="white"
        stroke="#FF0019"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M44.0301 56.0934C46.223 57.3595 46.2339 59.4112 44.056 60.6772C41.878 61.9433 38.3336 61.9433 36.1421 60.6772L30.7536 57.5657C28.5607 56.2997 28.5499 54.2479 30.7278 52.9819C32.9058 51.7158 36.4501 51.7158 38.6416 52.9819L44.0301 56.0934Z"
        fill="#FF0019"></path>
      <path
        d="M35.6332 60.4059C37.8261 61.672 37.8369 63.7237 35.659 64.9897C33.481 66.2558 29.9367 66.2558 27.7452 64.9897L22.3567 61.8782C20.1638 60.6122 20.153 58.5604 22.3309 57.2944C24.5088 56.0283 28.0532 56.0283 30.2447 57.2944L35.6332 60.4059Z"
        fill="#FF0019"></path>
      <path
        d="M40.494 41.7408C38.0936 41.7408 36.1476 39.7949 36.1476 37.3945C36.1476 34.994 38.0936 33.0481 40.494 33.0481C42.8944 33.0481 44.8403 34.994 44.8403 37.3945C44.8403 39.7949 42.8944 41.7408 40.494 41.7408Z"
        fill="#FBDED7"
        stroke="#FF0019"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M26.8891 39.4503C29.4945 41.9933 36.5805 45.3735 36.5805 45.3735L37.833 38.8383L36.2956 33.6412L32.2518 25.0271C31.0591 22.4869 29.0833 20.3972 26.6137 19.0646L23.859 17.5774L26.8891 39.4503Z"
        fill="#88BE43"
        stroke="#FF0019"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M29.1104 19.8502C28.1049 17.9532 25.988 18.0428 25.988 18.0428L14.5406 17.0698C10.258 17.9966 5.586 18.9194 2.31164 28.5063C-1.00885 38.229 3.02272 52.3401 3.02272 52.3401C6.98371 52.3876 8.95128 51.5096 13.2094 49.8392C13.2094 49.8392 16.8475 35.8258 20.0933 34.7022L30.2651 31.5446"
        fill="#88BE43"></path>
      <path
        d="M29.1104 19.8502C28.1049 17.9532 25.988 18.0428 25.988 18.0428L14.5406 17.0698C10.258 17.9966 5.586 18.9194 2.31164 28.5063C-1.00885 38.229 3.02272 52.3401 3.02272 52.3401C6.98371 52.3876 8.95128 51.5096 13.2094 49.8392C13.2094 49.8392 16.8475 35.8258 20.0933 34.7022L30.2651 31.5446"
        stroke="#FF0019"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M28.968 41.6201L30.8976 53.9997C37.1682 55.7679 41.1875 52.5532 41.1875 52.5532C41.1875 52.5532 40.7981 41.2008 40.3842 37.4407C40.0124 34.0686 38.5061 26.2688 31.4974 27.1874C21.6906 28.4738 22.5604 46.5296 22.5604 46.5296"
        fill="white"></path>
      <path
        d="M28.968 41.6201L30.8976 53.9997C37.1682 55.7678 41.1875 52.5532 41.1875 52.5532C41.1875 52.5532 40.7981 41.2008 40.3842 37.4407C40.0124 34.0686 38.5061 26.2688 31.4974 27.1874C21.6906 28.4738 22.5604 46.5296 22.5604 46.5296"
        stroke="#FF0019"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M19.3633 46.6884L21.2929 59.068C27.5635 60.8361 31.5828 57.6214 31.5828 57.6214C31.5828 57.6214 31.1933 46.2691 30.7795 42.5089C30.4076 39.1368 28.9014 31.337 21.8927 32.2557C12.0859 33.5421 12.9557 51.5979 12.9557 51.5979"
        fill="white"></path>
      <path
        d="M19.3633 46.6884L21.2929 59.068C27.5635 60.8361 31.5828 57.6214 31.5828 57.6214C31.5828 57.6214 31.1933 46.2691 30.7795 42.5089C30.4076 39.1368 28.9014 31.337 21.8927 32.2557C12.0859 33.5421 12.9557 51.5979 12.9557 51.5979"
        stroke="#FF0019"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M24.2442 50.3657C21.8438 50.3657 19.8978 48.4198 19.8978 46.0193C19.8978 43.6189 21.8438 41.673 24.2442 41.673C26.6447 41.673 28.5906 43.6189 28.5906 46.0193C28.5906 48.4198 26.6447 50.3657 24.2442 50.3657Z"
        fill="#FBDED7"
        stroke="#FF0019"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path d="M14.3818 33.9003L23.939 41.5508L20.1218 47.5975L4.76228 38.3009" fill="#88BE43"></path>
      <path
        d="M14.3818 33.9003L23.939 41.5508L20.1218 47.5975L4.76228 38.3009"
        stroke="#FF0019"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M21.4761 28.0232C15.5189 28.0232 10.6897 23.1939 10.6897 17.2367C10.6897 11.2795 15.5189 6.4502 21.4761 6.4502C27.4334 6.4502 32.2627 11.2795 32.2627 17.2367C32.2627 23.1939 27.4334 28.0232 21.4761 28.0232Z"
        fill="#FBDED7"
        stroke="#FF0019"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <path
        d="M20.2967 18.7579C19.3719 18.7579 18.6222 18.0082 18.6222 17.0834C18.6222 16.1586 19.3719 15.4089 20.2967 15.4089C21.2214 15.4089 21.9712 16.1586 21.9712 17.0834C21.9712 18.0082 21.2214 18.7579 20.2967 18.7579Z"
        fill="#FF0019"></path>
      <path
        d="M26.805 20.4501C25.8802 20.4501 25.1305 19.7004 25.1305 18.7756C25.1305 17.8508 25.8802 17.1011 26.805 17.1011C27.7297 17.1011 28.4795 17.8508 28.4795 18.7756C28.4795 19.7004 27.7297 20.4501 26.805 20.4501Z"
        fill="#FF0019"></path>
      <path
        d="M9.06408 6.46109C9.81991 4.68346 11.8445 3.8245 13.6872 4.44328C13.7198 4.0769 13.8094 3.71052 13.9613 3.35499C14.7565 1.48509 16.9548 0.630206 18.8722 1.44574C19.1544 1.56516 19.4137 1.71578 19.6484 1.88947C20.5494 0.250256 22.5984 -0.456723 24.3991 0.308605C25.425 0.745548 26.1618 1.57194 26.5024 2.53267C27.4849 1.98039 28.7184 1.87861 29.8514 2.36034C31.3753 3.00897 32.26 4.51791 32.1596 6.04857C32.6277 6.06078 33.1027 6.15984 33.5613 6.35525C35.4774 7.17078 36.3852 9.34735 35.59 11.2173C35.4082 11.6447 35.1531 12.0179 34.845 12.3313C36.3567 13.3029 37.0053 15.2162 36.2956 16.8867C35.5004 18.7566 33.3022 19.6114 31.3848 18.7959C29.7998 18.1215 28.9056 16.5162 29.0942 14.9231C28.4415 15.0086 27.7549 14.9245 27.0995 14.6463C25.984 14.1714 25.2106 13.2351 24.9161 12.1671C23.9771 12.6081 22.8508 12.6597 21.8073 12.216C21.2984 12.0002 20.8629 11.6868 20.5087 11.3095C20.487 11.3679 20.4653 11.4249 20.4409 11.4819C19.6742 13.2839 17.6034 14.1429 15.7403 13.4725C15.7267 13.5078 15.7132 13.5444 15.6983 13.5797C14.9031 15.4496 12.7048 16.3045 10.7888 15.489C8.87274 14.6734 7.9649 12.4969 8.76008 10.627C8.89849 10.3027 9.079 10.0096 9.2934 9.74902C8.7194 8.77471 8.59589 7.56566 9.0654 6.46245L9.06408 6.46109Z"
        fill="#FF0019"></path>
    </svg>
  );
}
